var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplyInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(-1007 -550)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    transform: "translate(1007 550)",
    fill: "none",
    stroke: "#a3d7ee",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(1013 553.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M10.711,7.209A7.473,7.473,0,0,0,5.263,5.134V2.763a.263.263,0,0,0-.449-.186L.077,7.314a.263.263,0,0,0,0,.372l4.737,4.737a.263.263,0,0,0,.449-.186V9.87c5.288.077,6.866,2.481,6.882,2.5a.263.263,0,0,0,.224.125.273.273,0,0,0,.067-.009.264.264,0,0,0,.2-.245A7.478,7.478,0,0,0,10.711,7.209Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#a3d7ee",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyInactive);
export default __webpack_public_path__ + "static/media/reply_inactive.1d295b8382f7f8dc73f97abeceaaa461.svg";
export { ForwardRef as ReactComponent };